import {
	browserTracingIntegration,
	init,
	replayIntegration,
	setUser,
} from '@sentry/react';

import { getCachedImsAuthId } from '@/auth/imsTokenStorage';
import { config } from '@/config/env';

const DSN =
	'https://eff5dadc28372305e34fcdf3cb72b85e@o4511462676365312.ingest.us.sentry.io/4511475872759808';

export const initSentry = (): void => {
	try {
		if (!config.SENTRY_ENABLED) {
			console.info('Sentry disabled (config.SENTRY_ENABLED=false)');
			return;
		}
		init({
			dsn: DSN,
			environment: config.ENV,
			...(config.SENTRY_RELEASE ? { release: config.SENTRY_RELEASE } : {}),
			tracesSampleRate: config.SENTRY_TRACES_SAMPLE_RATE,
			sendDefaultPii: false,
			integrations: [
				browserTracingIntegration(),
				replayIntegration({
					maskAllText: true,
					blockAllMedia: true,
					maskAllInputs: true,
				}),
			],
			replaysSessionSampleRate: 0.0,
			replaysOnErrorSampleRate: 1.0,
		});
		// Bind before React renders. The Instagram popup reports an
		// oauth_redirect failure from its own mount effect, which runs before
		// any provider effect and before the profile request returns.
		const cachedAuthId = getCachedImsAuthId();
		if (cachedAuthId) {
			setUser({ id: cachedAuthId });
		}
	} catch (err) {
		console.warn('Sentry init failed:', err);
	}
};
